import React from "react";
import CancelIcon from "../../assets/images/carbon_close-filled.svg";
import { FlexDiv } from "../../assets/styles/style";
import {
  DeleteNoBtn,
  DeleteYesBtn,
  PopupHeader,
  PopupTitleText,
  PopupWhiteDiv,
} from "../SideBar/style";
import { AreYouSureText } from "./Style";

const SureToResetPopup = ({ close, onSubmit }) => {
  return (
    <>
      <div id="popup-card">
        <PopupHeader>
          <FlexDiv style={{ width: "95%", justifyContent: "flex-end" }}>
            <img
              src={CancelIcon}
              alt=""
              style={{ width: "20px", height: "20px", cursor: "pointer" }}
              onClick={() => close(false)}
            />
          </FlexDiv>
        </PopupHeader>
        <PopupWhiteDiv>
          <PopupTitleText>Are you sure you want to?</PopupTitleText>
          <AreYouSureText color="#131313">
            This will delete all your practice history for this question type.
            You cannot undo this action.
          </AreYouSureText>
          <FlexDiv style={{ gap: "1.25rem" }}>
            <DeleteNoBtn onClick={() => close(false)}>Cancel</DeleteNoBtn>
            <DeleteYesBtn
              onClick={() => {
                onSubmit();
                // close(false);
              }}
            >
              Submit
            </DeleteYesBtn>
          </FlexDiv>
        </PopupWhiteDiv>
      </div>
    </>
  );
};

export default SureToResetPopup;
